// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KJW6","buttons":"styles_buttons__2ETVo"};